<ng-container *ngIf="user">
	<img *ngIf="!big ? user.avatarUrl : user.avatarBig" [src]="!big ? user.avatarUrl : user.avatarBig" alt="{{user.name}}" draggable="false"/>
	<div class="letter" *ngIf="!big ? !user.avatarUrl : !user.avatarBig" [class._empty]="!user.letter">
		{{user.letter ? user.letter : ''}}
		<span *ngIf="!user._id" class="placeholder-icon icon-user"></span>
	</div>
</ng-container>